<template>
  <div class="c-grade">
    <span class="c-grade__header">年级分布</span>
    <div class="c-grade__bgc" >
      <div class="grade-distribute" ></div>
      <EmptyLearning v-if="!show"/>
    </div>

  </div>
</template>

<script>
import * as echarts from 'echarts';
import EmptyLearning from './empty-learning.vue';

export default {
  name: 'GradeDistribute',
  components: {
    EmptyLearning,
  },
  data() {
    return {
      show: true,
    };
  },
  props: {
    gradeList: {
      default: () => [],
      type: Array,
    },
  },
  mounted() {
  },
  watch: {
    gradeList(n) {
      if (Number(n.length) === 0) {
        this.show = false;
        this.initCharts();
      } else {
        this.show = true;
        this.initCharts();
      }
    },
  },
  methods: {
    initCharts() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.querySelector('.grade-distribute'));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          type: 'category',
          data: this.gradeList.map((item) => item.grade_name),
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: '12',
            },
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: ['rgba(255, 255, 255, 0.3)'],
            },
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: '12',
            },
          },
        },
        series: [{
          data: this.gradeList.map((item) => item.student_num),
          type: 'bar',
          barMaxWidth: 24,
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#00F1FF',
              }, {
                offset: 0.72,
                color: '#48A6FF',
              }, {
                offset: 1,
                color: '#8A4FFF',
              }]),
              label: {
                formatter(params) {
                  return params.data;
                },
                show: true,
                position: 'top',
                textStyle: {
                  fontWeight: 500,
                  fontSize: '12',
                  color: '#fff',
                },

              },
            },
          },
        }],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-grade{
  box-sizing: border-box;

  &__header {
     display: block;
        position: relative;
        font-size: 28px;
        font-weight: 500;
        text-indent: 1em;
        color: #E3E2FF;
        &::before {
          content: '';
          position: absolute;
          width: 27px;
          height: 27px;
          top: 9px;
          left: -8px;
          background: url('../../images/cockpit-icon.png') no-repeat center / contain;
    }
  }
  &__bgc{
    margin-top:30px ;
    position: relative;
     width: 490px;
    height: 279px;
    background: linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
    border-radius: 8px ;
    // opacity: 0.38;
    }
    .grade-distribute{
      position: absolute;
      top: 0;
      left: 0;
      width: 490px;
      height: 279px;
    }
  }

</style>
